<template>
  <div>
    <ErrorMessage
      v-show="errorMessage != null && errorMessage != ''"
      :msg="errorMessage"
    ></ErrorMessage>
    <input
      v-show="!hidden"
      ref="inputFocus"
      v-model="filteredValue"
      :isFocus="isFocus"
      :type="type"
      :min="min"
      :maxlength="maxlength"
      class="form-control form-control-new"
      :class="[
        errorMessage != null && errorMessage != '' ? 'errorStyle' : '',
        right == true ? 'right' : '',
        textCenter == true ? 'text_center' : '',
        ellipsis === true ? 'ellipsis' : ''
      ]"
      :disabled="disabled"
      :placeholder="placeholder"
      @change="$emit('change', $event.target.value)"
      @input="change"
    />
  </div>
</template>

<script>
import ErrorMessage from './ErrorMessage.vue'
export default {
  name: 'InputText',
  components: { ErrorMessage },
  props: {
    // フォーカスフラグ
    isFocus: {
      type: Boolean,
      default: false
    },
    // メッセージ
    errorMessage: {
      default: () => {
        return ''
      },
      type: String
    },
    // 入力内容
    value: {
      default: () => {
        return ''
      },
      type: [String, Number]
    },
    // プレースホルダ
    placeholder: {
      default: () => {
        return ''
      },
      type: String
    },
    // 型
    type: {
      default: () => {
        return ''
      },
      type: String
    },
    // 最小値
    min: {
      default: () => {
        return 0
      },
      type: Number
    },
    // 非表示フラグ
    hidden: {
      default: () => {
        return false
      },
      type: Boolean
    },
    // 非活性フラグ
    disabled: {
      default: () => {
        return false
      },
      type: Boolean
    },
    // 中央に寄せフラグ
    textCenter: {
      default: () => {
        return false
      },
      type: Boolean
    },
    // 右に寄せフラグ
    right: {
      default: () => {
        return false
      },
      type: Boolean
    },
    // 最大文字数
    maxlength: {
      default: () => {
        return 0
      },
      type: Number
    },
    // 省略記号表示フラグ
    ellipsis: {
      default: () => {
        return false
      },
      type: Boolean
    },
    // 数字フラグ(全半角のアラビア数字、漢数字)
    isNumber: {
      default: () => {
        return false
      },
      type: Boolean
    }
  },
  data() {
    return {
      filteredValue: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.filteredValue = this.value
      }
    }
  },
  mounted() {
    this.focus()
  },
  methods: {
    focus() {
      if (this.isFocus === true) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.inputFocus && !this.$refs.inputFocus.value) {
              this.$refs.inputFocus.focus()
            }
          }, 800)
        })
      }
    },
    change(e) {
      if (this.isNumber) {
        const reg = /[^0-9０１２３４５６７８９〇一二三四五六七八九]/g
        this.filteredValue = this.filteredValue.replace(reg, '')
      }
      if (this.filteredValue.length > this.maxlength) {
        this.filteredValue = this.filteredValue.slice(0, this.maxlength)
      }
      this.$emit('input', this.filteredValue)
    }
  }
}
</script>

<style scoped lang="scss">
.text_center {
  text-align: center;
}
.errorStyle {
  background-color: rgb(255, 220, 221);
  border-color: red;
  border: 1;
}
.right {
  text-align: right;
}
.none {
  border: none;
}
.form-control-new {
  height: 25px !important;
  font-size: 14px !important;
}

.form-control {
  color: rgb(0, 0, 0);
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
